export default [
  {
    path: '/guardians',
    name: 'guardians.index',
    component: () => import('@/views/guardians/GuardiansIndex.vue'),
    meta: {
      requiresAuth: true,
      title: 'Guardians',
      roles: ['sponsor', 'site_representative']
    }
  },
  {
    path: '/guardians/create',
    name: 'guardians.create',
    component: () => import('@/views/guardians/GuardianCreate.vue'),
    meta: {
      requiresAuth: true,
      title: 'Create Guardian',
      roles: ['sponsor', 'site_representative']
    }
  },
  {
      path: '/guardians/:id/income-eligibility',
      name: 'IncomeEligibilityForm',
      component: () => import('@/components/income-eligibility/IncomeEligibilityForm.vue'),
      meta: {
        requiresAuth: true,
        title: 'Income Eligibility Application',
          roles: ['sponsor', 'site_representative']
      }
    },
    {
    path: '/guardians/:id',
    name: 'guardians.show',
    component: () => import('@/views/guardians/GuardianShow.vue'),
    meta: {
      requiresAuth: true,
      title: 'Guardian Details',
      roles: ['sponsor', 'site_representative']
    }
  },
  {
    path: '/guardians/:id/edit',
    name: 'guardians.edit',
    component: () => import('@/views/guardians/GuardianEdit.vue'),
    meta: {
      requiresAuth: true,
      title: 'Edit Guardian',
      roles: ['sponsor', 'site_representative']
    }
  }
]
